const o={textColor:"#000000",bgColor:"#FFFFFF",actionColor:"#15E0FB"},t={darkTheme:o};export{t as default};
//# sourceMappingURL=presets.js.map
